(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let sectionObserver;

  function prepareSections() {
    const sections = [...document.querySelectorAll('#MainContent > .shopify-section')];
    if (!sections.length) return;

    sectionObserver?.disconnect();
    sections.forEach((section) => {
      section.classList.remove('home-motion-section', 'home-motion-visible');
    });

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      sections.forEach((section) => section.classList.add('home-motion-visible'));
      return;
    }

    sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('home-motion-visible');
        sectionObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });

    sections.slice(1).forEach((section) => {
      section.classList.add('home-motion-section');
      sectionObserver.observe(section);
    });
  }

  /* Quiet parallax: 0.2x drift on photos inside clipped media frames only.
     Off by default under prefers-reduced-motion; nothing here moves layout. */
  const PARALLAX_FACTOR = 0.2;
  const PARALLAX_LIMIT = 36;
  const PARALLAX_SELECTOR = [
    '.editorial-hero__background img',
    '.editorial-collections__media img',
    '.editorial-spotlight__media img',
    '.editorial-recipes__media img'
  ].join(', ');
  let parallaxTicking = false;

  function applyParallax() {
    parallaxTicking = false;
    if (reducedMotion.matches) return;
    const targets = document.querySelectorAll(PARALLAX_SELECTOR);
    if (!targets.length) return;
    const mid = window.innerHeight / 2;
    targets.forEach((node) => {
      const frame = node.parentElement;
      if (!frame) return;
      const rect = frame.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > window.innerHeight + 200) {
        node.style.transform = '';
        return;
      }
      const delta = (mid - (rect.top + rect.height / 2)) * PARALLAX_FACTOR;
      const shift = Math.max(-PARALLAX_LIMIT, Math.min(PARALLAX_LIMIT, delta));
      node.style.transform = `translate3d(0, ${shift.toFixed(2)}px, 0) scale(1.06)`;
    });
  }

  function requestParallax() {
    if (parallaxTicking) return;
    parallaxTicking = true;
    window.requestAnimationFrame(applyParallax);
  }

  function resetParallax() {
    document.querySelectorAll(PARALLAX_SELECTOR).forEach((node) => {
      node.style.transform = '';
    });
  }

  function initializeParallax() {
    if (!window.matchMedia('(hover: hover)').matches) return;
    window.addEventListener('scroll', requestParallax, { passive: true });
    window.addEventListener('resize', requestParallax, { passive: true });
    reducedMotion.addEventListener('change', () => {
      if (reducedMotion.matches) resetParallax();
      else requestParallax();
    });
    requestParallax();
  }

  function initializeHomepage() {
    document.body.classList.add('template-index-motion');
    prepareSections();
    initializeParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeHomepage, { once: true });
  } else {
    initializeHomepage();
  }

  document.addEventListener('shopify:section:load', prepareSections);
})();
